import quickEditOptions from "@lab/meta/quickEdit";
import * as api from "@/api/bulkedit.api";

const state = {
	editing: [],
	fecthing: false,
	errorMessage: null,
	lastFetched: null, // Timestamp,
	category: null,
	option: null
};

const getters = {
	editing: (state) => state.editing,
	fetching: (state) => state.fetching,
	category: (state) => state.category,
	categories: () => {
		return Object.entries(quickEditOptions).map(([key, value]) => {
			return {
				value: key,
				label: value.label
			};
		});
	},
	option: (state) => state.option,
	options: (state) => {
		if (state.category) {
			const options = quickEditOptions[state.category].options;
			if (options) {
				return Object.entries(options).map(([value, label]) => {
					return {
						value,
						label
					};
				});
			}
		}
		return null;
	}
};

const actions = {
	updateCategory({ commit }, category) {
		commit("UPDATE_CATEGORY", category);
	},
	updateOption({ commit }, option) {
		commit("UPDATE_OPTION", option);
	},
	async submitUpdates({ state }, { id, options }) {
		await api.update(
			id, // organisation id
			`${state.category}${state.option ? `/${state.option}` : ``}`,
			options
		);
	}
};

const mutations = {
	UPDATE_CATEGORY(state: any, category) {
		state.category = category;
	},
	UPDATE_OPTION(state: any, option) {
		state.option = option;
	}
};

export default { namespaced: true, state, getters, actions, mutations };
